export enum RaceEthnicity {
  HISPANIC_OR_LATINO = 1,
  WHITE = 2,
  BLACK_OR_AFRICAN_AMERICAN = 3,
  NATIVE_HAWAIIAN_OR_PACIFIC_ISLANDER = 4,
  ASIAN = 5,
  AMERICAN_INDIAN_OR_ALASKAN_NATIVE = 6,
  TWO_OR_MORE = 7,
}
